import type { Meta } from "@grafana/faro-web-sdk";
import { APP_KEY } from "./constants";
import { getDistributionChannel } from "./channel";

export const getSdkMeta = (): Pick<Meta, 'sdk'> => ({
  sdk: {
    name: APP_KEY,
    version: __MONTILLA_SDK_VERSION__,
    // One integration entry identifying the distribution channel/package that
    // booted the SDK (CDN bundle vs npm lib vs Nuxt module). Kept an array so
    // future integrations can be appended.
    integrations: [
      { name: getDistributionChannel(), version: __MONTILLA_SDK_VERSION__ },
    ],
  },
});
